import { render, staticRenderFns } from "./Automacao.vue?vue&type=template&id=27c9e68f&"
import script from "./Automacao.vue?vue&type=script&lang=js&"
export * from "./Automacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports